import { ApiDataModel, ApiModule } from '@/api/apiConstants'

const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.COMPONENTS)

export const apiDietComponents = {
	fetchComponentByQuery: async (
		query: string,
		filters?: IApiFilters,
		isExcludeNestedSemiProducts: boolean = false,
	): Promise<IDietComponentsModel> => {
		const { data } = await apiCommon<IDietComponents>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(null, { name: query, ...filters }, undefined, {
				exclude_nested_semi_products: isExcludeNestedSemiProducts,
			}),
		})

		return Components(data)
	},
}
